(function () {
  'use strict';

  function setState(item, open) {
    if (!item) return;
    var button = item.querySelector('[data-pdp-re-faq-button]');
    var answer = item.querySelector('[data-pdp-re-faq-answer]');
    if (!button || !answer) return;

    item.classList.toggle('is-open', open);
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    answer.hidden = !open;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-pdp-re-faq-button]');
    if (!button) return;

    var item = button.closest('.pdp_re_faq_item');
    if (!item) return;

    var willOpen = !item.classList.contains('is-open');
    var section = item.closest('.shopify-section') || document;

    section.querySelectorAll('.pdp_re_faq_item.is-open').forEach(function (other) {
      if (other !== item) setState(other, false);
    });

    setState(item, willOpen);
  });
})();
